export { default } from "./GameSection"
